module.exports = __webpack_public_path__ + "img/base_activites_tennis.044303ee.svg";